<template>
  <el-dialog
    title="积分变更记录"
    :visible.sync="dialogVisible"
    width="850px">
    <div class="infinite-list-wrapper">
      <el-table :show-header="false" :data="tableData" style="width: 100%">
        <el-table-column prop="addTime" width="180"></el-table-column>
        <el-table-column prop="operator" width="120"></el-table-column>
        <el-table-column prop="score" width="100">
          <template #default="{ row }">
            <span v-if="row.score > 0" style="color: #67C23A">+{{ row.score }}</span>
            <span style="color: #F56C6C" v-else>{{ row.score }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="description"></el-table-column>
      </el-table>
      <div class="pagination">
        <el-pagination
          background
          :current-page="curPage"
          layout="total, prev, pager, next"
          :page-size="pageSize"
          :total="total"
          @current-change="handleCurrentChange"
          @size-change="handleSizeChange"
        />
      </div>
    </div>
  </el-dialog>
</template>
<script>
export default {
  components: {},
  data() {
    return {
      searchForm: {
        userId: ''
      },
      tableData: [],
      /*一共多少条数据*/
      total: 0,
      /*当前是第几页*/
      curPage: 1,
      /*一页多少条*/
      pageSize: 10,
      /*是否加载完成*/
      loading: true,
      dialogVisible: false
    }
  },
  mounted() {
  },
  methods: {
    show(id) {
      this.dialogVisible = true
      this.searchForm.userId = id
      this.fetchData()
    },
    fetchData() {
      let self = this
      let params = self.searchForm
      params.curPage = self.curPage
      params.pageSize = self.pageSize
      this.$http.get(`cCardUserCard/log`, {params}).then(({data}) => {
        this.tableData = data.records
        this.total = data.total
      })
      self.loading = false
    },
    /*选择第几页*/
    handleCurrentChange(val) {
      let self = this
      self.curPage = val
      self.loading = true
      self.fetchData()
    },
    /*每页多少条*/
    handleSizeChange(val) {
      this.curPage = 1
      this.pageSize = val
      this.fetchData()
    },
  }
}
</script>
<style scoped lang="less">
::v-deep .el-dialog__body {
  padding-top: 10px;
}

.infinite-list-wrapper {
  min-height: 300px;
}

.pagination {
  text-align: center;
  margin-top: 20px;
}
</style>
